import { formatMoney } from '//modernfoyer.com/cdn/shop/t/20/assets/theme.js?v=108202387679774844221793143935';

class MFMobilePrice extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (this.isConnected && !this.onVariantChange) this.initialize();
    });
  }
  initialize() {
    this.onVariantChange = (event) => {
      if (event.target.id === this.getAttribute('form')) this.render(event.detail.variant);
    };
    document.addEventListener('variant:change', this.onVariantChange);
    this.render(JSON.parse(this.querySelector('[data-mf-initial]').textContent));
  }
  disconnectedCallback() {
    document.removeEventListener('variant:change', this.onVariantChange);
    this.onVariantChange = null;
  }
  money(value) {
    const template = document.createElement('template');
    template.innerHTML = formatMoney(value, window.themeVariables.settings.moneyFormat);
    return template.content.textContent.trim();
  }
  render(variant) {
    this.hidden = !variant;
    if (!variant) return;
    const current = this.money(variant.price);
    const compare = this.money(variant.compare_at_price || 0);
    const sale = variant.compare_at_price > variant.price;
    const now = this.querySelector('[data-mf-now]');
    const parts = current.match(/^(.*?)(\d[\d.,\s]*?)[.,](\d{2})([^\d]*)$/);
    now.replaceChildren();
    if (parts) {
      for (const [value, name] of [[parts[1], 'sym'], [parts[2], 'int'], [parts[3], 'cents'], [parts[4], 'sym']]) {
        if (!value) continue;
        const span = document.createElement('span');
        span.className = `mf-price__${name}`;
        span.textContent = value;
        now.append(span);
      }
    } else {
      now.textContent = current;
    }
    const compareElement = this.querySelector('[data-mf-compare]');
    compareElement.hidden = !sale;
    compareElement.textContent = compare;
    const saveElement = this.querySelector('[data-mf-save]');
    saveElement.hidden = !sale;
    saveElement.textContent = sale ? this.dataset.saveTemplate.replace('__amount__', this.money(variant.compare_at_price - variant.price)).replace('__percent__', Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)) : '';
    const saleLabel = this.querySelector('[data-mf-sale-label]').textContent;
    const regularLabel = this.querySelector('[data-mf-regular-label]').textContent;
    this.querySelector('[data-mf-readable]').textContent = `${saleLabel} ${current}${sale ? `, ${regularLabel} ${compare}` : ''}`;
  }
}
if (!customElements.get('mf-mobile-price')) customElements.define('mf-mobile-price', MFMobilePrice);
